export function isPublicReviewPath(pathname: string) {
  return pathname.startsWith("/client-review/") || pathname.startsWith("/delivery-asset/");
}
